import { Chip, ChipProps } from '@mui/material'
import { launchOfferLabel, type LaunchOfferInfo } from '@tnf-recruit/shared'

/** The launch-discount chip. Renders nothing unless the offer is live. */
export function LaunchOfferChip({
  offer,
  ...props
}: { offer: LaunchOfferInfo | null | undefined } & Omit<ChipProps, 'label'>): JSX.Element | null {
  const label = launchOfferLabel(offer)
  if (!label) return null

  return <Chip color="success" label={label} {...props} />
}
